export const buildNewChatLink = (token: string) => `/new-chat/?token=${encodeURIComponent(token)}`;
